import { useParams } from "react-router-dom";
import AppNavBarWithBackAction from "../../modules/AppNavBarWithBackAction";
import ViewTicketFullContentLoader from "./ViewTicketFullContentLoader";
import ViewTicketFull from "./ViewTicketFull";
import { useEffect, useState } from "react";

function ViewTicket() {
  const [isLoading, setLoading] = useState(true);
  const { ticketId } = useParams();

  const ticket = {
    ticket_id: "6788b8f893cf72b4f47e6376",
    pidge_id: "jrFCK21bzBSqFBlt_fcJl",
    issue_category: "OTHERS",
    issue_subcategory: "RIDER_BEHAVIOR",
    description: "ORDER NOT YET DELIVERED",
    status: "OPEN",
    created_at: "2025-01-16T07:44:56.655Z",
    order_status: "PENDING",
    update_info: {
      callback_url: "https://play.svix.com/in/e_AIR7WIno8Vkqb0qWiwYBLheWwql/",
      callback_auth: "Bearer msdbksfsdf",
      poc_number: "999988881111",
      poc_email: "helpdesk@client.com",
    },
  };

  useEffect(() => {
    const id = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(id);
  }, []);

  return (
    <div className="px-6 mt-10">
      <AppNavBarWithBackAction title="Ticket History" />
      <div className="mt-8">
        {isLoading ? (
          <>
            <ViewTicketFullContentLoader />
          </>
        ) : (
          <ViewTicketFull ticket={ticket} />
        )}
      </div>
    </div>
  );
}

export default ViewTicket;
